'use strict';

const Mn = require('backbone.marionette');
const MarkdownWriterView = require('common/ui/view/markdown/writer');
const DescEditTemplate = require('balus/ui/template/body/project/modal/description-edit.hbs');

module.exports = Mn.View.extend({
    template: DescEditTemplate,
    regions: {
        description: '.project-description-edit'
    },

    initialize: function() {
        const projectJSON = this.model.toJSON();
        this._desc = projectJSON.description;
    },

    onRender: function() {
        this.showChildView('description', new MarkdownWriterView({
            project: this.model,
            markdown: this.model.get('description'),
            useDataContentSelector: true,
            autoFocus: true
        }));
        this.listenTo(this.getChildView('description'), 'change', function(desc){
            this._desc = desc;
            this.triggerMethod('change:desc');
        });

        $.material.init();
    },

    getJSON: function() {
        return this._desc;
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/project/modal/description-edit.js